import { FieldPathUtils } from '../../../utils/fieldpath-utils';
import { SerializedFieldContext } from '../../content-control-to-field-map.service';
import { PasteLocation } from '../paste-location';
import { IPasteRule } from './ipasterule';

export class PasteEntityFieldInDataFieldLocationRule implements IPasteRule {
  canPaste(pasteLocation: PasteLocation, pasteField: SerializedFieldContext): boolean {
    pasteLocation.location = pasteLocation.location as SerializedFieldContext;
    return FieldPathUtils.tailless(pasteField.path) === pasteLocation.location.path; // pasting child inside parent?
  }
}
